module.exports = __webpack_public_path__ + "media/images/common/project_off-12d8d2a11dec0eb6d1b2edf31fe111c8.png";